import { Check } from 'lucide-react';

interface Props {
  background: string;
  saasCategory: string;
  selected: boolean;
  onClick?: () => void;
}

const SaasCategoryFilter = ({
  background,
  saasCategory,
  selected,
  onClick = () => { }
}: Props) => {
  return (
    <div className="overflow-hidden pl-0 mr-2 h-50">
      <div
        onClick={onClick}
        className="h-full block relative bg-cover bg-top bg-no-repeat bg-center cursor-pointer"
        style={{
          backgroundImage: `url('${background}')`,
        }}
      >
        {selected && (
          <span className="absolute top-2 left-2 bg-holos-dark rounded-full w-8 h-8 flex items-center justify-center">
            <Check className="text-white w-4 h-4" />
          </span>
        )}

        <div className={`absolute bottom-4 left-4 flex items-center px-3 py-2 rounded-full bg-${saasCategory.toLowerCase()}`}>
          <div className="text-xs font-bold italic uppercase mr-1 text-black">
            {saasCategory.toLowerCase()}
          </div>
          <img
            src={`https://cache.beholos.com/img/fitness-pass-v2/corporate/saas-cat-${saasCategory.toLowerCase()}.svg`}
            alt={saasCategory}
            className="h-7"
          />
        </div>
      </div>
    </div>
  );
};

export default SaasCategoryFilter;